<ng-container *ngIf="initialized">
    <!--            tags and watch list-->
<!--    <ng-container>-->
<!--        <div class="flex flex-column gap-2">-->
<!--            &lt;!&ndash;ADD WATCHLIST: CREATE Tm.TicketComment &ndash;&gt;-->
<!--            <mvs-ticket-watchlist [ticketId]="objectIdentifier.objectId"></mvs-ticket-watchlist>-->
<!--        </div>-->

<!--    </ng-container>-->

    <div>

        <div class="flex justify-content-between align-items-center mt-3 px-3">
                <h5 class="text-color text-xl font-medium mb-0">Aktivitäten</h5>
                <p-select
                        [options]="actions"
                        [(ngModel)]="selectedAction"
                        optionLabel="label"
                        optionValue="code"
                        class="w-auto"
                ></p-select>


<!--            &lt;!&ndash; ADD TICKET TYPE ACTION    &ndash;&gt;-->
<!--            <mvs-ticket-type-action-->
<!--                    *ngIf="ticketTypeDto.id"-->
<!--                    [dtoTicketType]="ticketTypeDto"-->
<!--                    [ticketId]="objectIdentifier.objectId"-->
<!--                    (onAction)="refreshHistory()"-->
<!--            ></mvs-ticket-type-action>-->

        </div>

        <!-- ADD COMMENTS: CREATE Tm.TicketComment-->
        <div class="flex align-items-center">

            <div class="pl-3">
                <p-avatar
                        icon="far fa-user"
                        shape="circle"
                ></p-avatar>
            </div>
<!--            // TODO Dependency-->
            <mvs-comments
                    class="w-full"
                    [objectIdentifier]="objectIdentifier"
                    [euVisible]="euVisible"
                    [documentTypeId]="documentTypeId"
                    [hideLabel]="true"
                    [referenceId]="objectIdentifier.objectId"
                    [serviceInterface]="ticketCommentService"
                    (onInputChange)="handleCommentChange($event)"
                    (onComment)="refreshHistory($event)"
                    (onUploadDocument)="handleDocumentUpload($event)"
            ></mvs-comments>

        </div>


    </div>
    <!--TICKET HISTORY-->
<!--    // TODO Dependency-->
    <mvs-ticket-history [euVisible]="euVisible"
                        [documentTypeId]="documentTypeId"
                        [objectIdentifier]="objectIdentifier"
                        [selectedAction]="selectedAction"
                        [highlightCommentId]="highlightCommentId">
    </mvs-ticket-history>
</ng-container>
